import React, { useCallback, useEffect, useState } from "react";
import "./TextList2.css";
import { shallowEqual, useSelector } from "react-redux";
import { useGetLink } from "../../utils/useOpenLink";
import CustomLink from "../../utils/customLink";
import { useGetDateToDisplay } from "../../utils/dateFunctions";
import { selectCountryLanguageCodes } from "../../redux/authSlice";
import { Button } from "../Button";
import parse from "html-react-parser";
import { APP_COLORS } from "../../constants/styles";
import useCustomTranslation from "../../utils/useCustomTranslation";

function TextList2({ heading, contents: contentToRender = [], colors: colorObj }) {
    const [fullContentList, setFullContentList] = useState([]);
    const [contentReferenceData, setContentReferenceData] = useState([]);
    const [visibleCount, setVisibleCount] = useState(3);

    const content = useSelector((state) => state.layout.content);
    const { getLink } = useGetLink();
    const getDateToDisplay = useGetDateToDisplay();
    const { languageCode } = useSelector(selectCountryLanguageCodes, shallowEqual);
    const { t } = useCustomTranslation();

    const setCurrentContent = useCallback(
        (contentKey) => {
            const keys = content[contentKey];
            const allItems = keys.map((k) => content[k]);
            const initialItems = allItems.slice(0, 3);
            setFullContentList(allItems);
            setContentReferenceData(initialItems);
        },
        [content],
    );

    useEffect(() => {
        if (contentToRender.length > 0) {
            setCurrentContent(contentToRender[0].contentKey);
        }
    }, []);

    const handleLoadMore = () => {
        const nextCount = visibleCount + 3;
        const nextItems = fullContentList.slice(0, nextCount);
        setContentReferenceData(nextItems);
        setVisibleCount(nextCount);
    };

    const showLoadMore = fullContentList.length > contentReferenceData.length;

    return (
        <section className="txtLinkWrapper2 py-50" style={APP_COLORS(colorObj)}>
            <div className="container">
                <div className="row">
                    <div className="col-12 mb-6">
                        <h2 className="text-accent_color1">{heading}</h2>
                        <div className="line bg-primary_color"></div>
                    </div>
                    <div className="col-12">
                        {contentReferenceData.map((card) => (
                            <div
                                className="txtLinkHldr border-b border-solid border-accent_color2"
                                data-aos="fade-up"
                                key={card.title}
                            >
                                <CustomLink to={getLink(card.path, card.type, card.language)}>
                                    <h2
                                        className="hover:underline text-accent_color1"
                                        data-aos="fade-up"
                                    >
                                        {card.title}
                                    </h2>
                                </CustomLink>
                                <div>
                                    <span className="minut text-accent_color3" data-aos="fade-up">
                                        {getDateToDisplay(card.date, languageCode)}
                                        {card?.date && card?.summary ? " • " : ""}
                                    </span>
                                    <span className="minut text-accent_color4">
                                        {parse(card.summary)}
                                    </span>
                                </div>
                            </div>
                        ))}
                        {showLoadMore && (
                            <div className="text-start mt-4">
                                <Button
                                    className="button max-w-auto p-2 px-6 text-accent_color4"
                                    data-aos="fade-up"
                                    onClick={handleLoadMore}
                                    style={{ "--primary_color": colorObj?.primary_color }}
                                >
                                    <span>{t("constantString.load_more")}</span>
                                </Button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default TextList2;
